import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { t } from "i18next";
import { toast } from "react-toastify";
import { getAISettingInitial, updateAIModules } from "common-lib";
import { AIOptionPanel, AIOptionResult } from "common_ui_lib";
import { myAIModuleState, trainUuidState } from "../../recoil/upgrade";
import { projectInfoState } from "../../recoil";
import { editProjectConfig } from "../../services/projectService";

const DEFAULT_FAVORITES = ["labelscore", "model1"];

// ponytail: 사용자 계정 config("aiOptionFavorites")에서 불러오도록 바뀌기 전까지 기본값 사용
const loadFavorites = () => DEFAULT_FAVORITES;

interface AIOptionModalProps {
  open: boolean;
  onClose: () => void;
}

export default function AIOptionModal({ open, onClose }: AIOptionModalProps) {
  const { id } = useParams();
  const myAIModule = useRecoilValue(myAIModuleState);
  const trainUuid = useRecoilValue(trainUuidState);
  const projectData = useRecoilValue(projectInfoState);
  const [aiSettingInit, setAiSettingInit] = useState<any>(null);

  // AIOptionPanel은 필드 스펙(limit)이 있어야 필드를 그린다 - 모달 열 때 AI 서버에서 받아옴
  useEffect(() => {
    if (!open || !myAIModule?.serverAddress) return;
    getAISettingInitial(myAIModule.serverAddress).then(setAiSettingInit).catch(console.error);
  }, [open, myAIModule?.serverAddress]);

  // AIOptionRender.handleSave와 동일한 요청. 템플릿 타입 병합은 AIOptionPanel이 해서 result로 넘겨준다
  const handleSave = async (result: AIOptionResult) => {
    try {
      const config = await (await fetch("/config.json")).json();
      const data = {
        train_id: trainUuid,
        site: config.SITE_OPTION,
        options: result,
        type: "preview",
        total: projectData!.imageCount,
        trained_count: 0,
        is_complete: false,
        epoch: myAIModule?.desc?.epoch || 1,
        iteration: myAIModule?.desc?.iteration || 0,
      };
      await updateAIModules(myAIModule!.serverAddress, data, myAIModule);
      // augmentation on/off를 프로젝트에 저장 → 백엔드가 학습 시작/학습·검증 완료 시에도 이 값을 따른다 (DefectPreview와 동일)
      const augModes = Object.fromEntries(
        Object.entries(result)
          .filter(([key]) => myAIModule?.options?.[key]?.tag?.includes("augmentation"))
          .map(([key, o]) => [key, o.para.mode]),
      );
      if (Object.keys(augModes).length) await editProjectConfig(Number(id), { augModes });
      toast.success(t("ModuleUpdateSuccessMsg"));
      onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("AIOption")}</DialogTitle>
      <DialogContent dividers>
        <AIOptionPanel
          aiSettingCurrent={myAIModule?.options}
          aiSettingInit={aiSettingInit}
          favorites={loadFavorites()}
          onSave={handleSave}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
